export const gridStyles = {
  // Main container
  container: {
    spacing: 4,
    align: 'stretch' as const,
    flex: '1',
    overflow: 'hidden',
  },

  // Grid scroll container
  gridContainer: {
    flex: '1',
    overflowY: 'auto' as const,
    pr: { base: 0, md: 2 },
    css: {
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#CBD5E0',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#A0AEC0',
      },
    },
  },

  // Grid layout
  grid: {
    gap: 4,
    pb: 4,
  },

  // Loading state
  loading: {
    container: {
      spacing: 4,
      py: 10,
    },
    spinner: {
      size: 'lg' as const,
      color: 'blue.500',
      thickness: '3px',
    },
    text: {
      color: '#4A5568',
      fontSize: '14px',
      fontWeight: '500',
    },
  },

  // Empty state
  empty: {
    container: {
      textAlign: 'center' as const,
      py: 10,
    },
    text: {
      color: '#718096',
      fontSize: '15px',
      fontWeight: '400',
    },
  },

  // Load More button
  loadMore: {
    container: {
      textAlign: 'center' as const,
      py: 4,
    },
    button: {
      variant: 'outline' as const,
      size: 'md',
      px: 6,
      py: 2,
      fontSize: '14px',
      fontWeight: '600',
      color: '#1A202C',
      bg: '#FFFFFF',
      borderRadius: 'md',
      _hover: {
        bg: '#F7FAFC',
      },
      _loading: {
        bg: 'FFFFFF',
      },
    },
  },

  // All loaded message
  allLoaded: {
    container: {
      textAlign: 'center' as const,
      py: 4,
      borderTop: '1px',
      borderColor: '#E2E8F0',
    },
    text: {
      fontSize: '13px',
      color: '#718096',
      fontWeight: '400',
    },
  },

  // Colors
  colors: {
    // DataGrid colors
    loadingSpinner: 'blue.500',
    loadingText: '#4A5568',
    emptyText: '#718096',
    allLoadedText: '#718096',
    scrollbarThumb: '#CBD5E0',
    scrollbarThumbHover: '#A0AEC0',
  },
}

export const gridColors = gridStyles.colors